import i18next from "i18next";
import { useState, useEffectWithCleanup } from "Shared/haunted/CustomHooks";
import { HauntedFunc } from "Shared/haunted/HooksHelpers";
import { PUB_SUBS } from "Services/pub-sub-service/PubSub";
import { unsafeHTML } from "lit-html/directives/unsafe-html";
import { deleteLoginInfo } from "Services/common";
import { iconButton } from "Components/iconButton";
import { html } from "lit-html";

export const useShadowDOM = false;
export const name = "ac-pcra-login-info-modal";

export type PcraLoginInfoModalType = "none" | "gestor" | "delegado";

export const Component: HauntedFunc<{}> = () => {
	const getUserTitle = () => (type === "gestor" ? "Gestor" : "Delegado");

	//COMPONENTS

	const [type, setType] = useState<PcraLoginInfoModalType>("none");

	useEffectWithCleanup(() => {
		const sub = PUB_SUBS.PcraLoginInfoModalOpened.subscribe((e) => setType(e.modalType));
		return () => sub.unsubscribe();
	}, []);

	//HANDLERS:

	const handleAcceptClick = async () => {
		try {
			await deleteLoginInfo();
		} catch (e) {
			// eslint-disable-next-line no-console
			console.error("Could not delete login info", e);
		}
		setType("none");
	};

	const acceptButton = iconButton({
		isAction: true,
		icon: html`<i class="jsh-circle-chevron-right1 text-base"></i>`,
		label: i18next.t("Aceptar"),
		onClick: handleAcceptClick,
	});

	//TEMPLATES:

	const bannerTemplate = () => {
		const userType = getUserTitle();

		return html`
			<div class="dg-new-modal-info-bar pcra-login-modal-header">
				${unsafeHTML(
					i18next.t("Sr. {{-userType}}", {
						userType,
					})
				)}
			</div>
		`;
	};

	const loginInfoModalMessageTemplate = () =>
		type === "gestor"
			? html`
					<p>${i18next.t("Login-Info-Modal-Gestor-Paragraph-1")}</p>
					<p>${i18next.t("Login-Info-Modal-Gestor-Paragraph-2")}</p>
				`
			: html`
					<p>${i18next.t("Login-Info-Modal-Delegado-Paragraph-1")}</p>
					<p>${i18next.t("Login-Info-Modal-Delegado-Paragraph-2")}</p>
				`;

	const contentTemplate = () => html` <div class="pcra-login-info-content">${loginInfoModalMessageTemplate()}</div> `;

	const footerTemplate = () => html` <div class="pcra-modal-footer">${acceptButton.htmlTemplate()}</div> `;

	return type !== "none"
		? html`
				<div class="fixed inset-0 z-[100001] bg-n-blue/75 backdrop-blur-xs">
					<div
						class="pcra-login-info-modal absolute w-[95%] max-w-[95%] overflow-hidden rounded-2xl bg-white all-center"
						data-test-id="modal-content"
					>
						${bannerTemplate()} ${contentTemplate()} ${footerTemplate()}
					</div>
				</div>
			`
		: html``;
};
